<script lang="ts">
  interface Props {
    type?: "warning" | "success" | "info" | "danger";
    lang?: string;
    children?: import('svelte').Snippet;
  }

  let { type = "warning", lang = "", children }: Props = $props();
</script>

<div
  class="rounded-2xl outline outline-$primary-dark outline-1 mt-4 text-center border-s-10 border-s-solid bg-$bg text-base"
  class:border-$warning={type === "warning"}
  class:border-$secondary-green={type === "success"}
  class:border-$primary-light={type === "info"}
  class:border-$danger={type === "danger"}
  lang={lang ? lang : undefined}
>
  <p class="p-4">
    {@render children?.()}
  </p>
</div>
